let apiURL = {

    prod: process.env.REACT_APP_PROD_ENDPOINT ? process.env.REACT_APP_PROD_ENDPOINT : 'http://localhost:3001/api/v1',
    dev:  process.env.REACT_APP_DEV_ENDPOINT ? process.env.REACT_APP_DEV_ENDPOINT : 'http://localhost:3002/api/v1',
};

let apiURLv2 = {
    prod: process.env.REACT_APP_PROD_ENDPOINT ? process.env.REACT_APP_PROD_ENDPOINT.replace('/api/v1', '/api/v2') : 'http://localhost:3001/api/v2',
    dev:  process.env.REACT_APP_DEV_ENDPOINT ? process.env.REACT_APP_DEV_ENDPOINT.replace('/api/v1', '/api/v2') : 'http://localhost:3002/api/v2',
};

export {
    apiURL,
    apiURLv2
};
